import React, { useEffect , useState } from "react";
import { Field } from "formik";
import {toAbsoluteUrl} from "../../../../../_helpers";
import SVG from "react-inlinesvg";
import {OverlayTrigger,Tooltip} from "react-bootstrap";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";

export const ShapeLabFancy = ({labFancyData,language}) => {
    const [shape, setShape] = useState( labFancyData.length !== 0 && labFancyData[0].lab_shape !== null ? labFancyData[0].lab_shape : [] );
    // const ShapeData = ([
    //     {
    //         id: 1,
    //         shape:"round"
    //     },
    //     {
    //         id: 2,
    //         shape:"princess"
    //     },
    //     {
    //         id: 3,
    //         shape:"oval"
    //     },
    //     {
    //         id: 4,
    //         shape:"heart"
    //     },
    //     {
    //         id: 5,
    //         shape:"cushion"
    //     },
    //     {
    //         id: 6,
    //         shape:"emerald"
    //     },
    //     {
    //         id: 7,
    //         shape:"marquise"
    //     },
    //     {
    //         id: 8,
    //         shape:"cushion modified"
    //     },
    //     {
    //         id: 9,
    //         shape:"pear"
    //     },
    //     {
    //         id: 10,
    //         shape:"asscher"
    //     },
    //     {
    //         id: 11,
    //         shape:"radiant"
    //     },
    //     {
    //         id: 12,
    //         shape:"square radiant"
    //     },
    //     {
    //         id: 13,
    //         shape:"triangle"
    //     },
    //     {
    //         id: 14,
    //         shape:"trilliant"
    //     },
    // ]);
    const newShapeData =shape.length!==0?shape.split(',').map((value,index) => {
        return {
            id: index,
            shape:value,
            multilingualshape:language[`${value.toUpperCase()}`] || value.toUpperCase()
        }
    }):null
    const [shapeImages] = useState( labFancyData.length !== 0 && labFancyData[0].shapeImages !== null ? labFancyData[0].shapeImages : [] );    
    // function reasonGroup (x) {
    //     var y = x.replace(/,\s*$/, "");
    //     var reason = y.split(',').map(function (x, index) {
    //         return <span className="label label-outline-danger label-pill label-inline bg-danger-o-20 font-weight-bold mr-1 text-nowrap" key={index}>{ x }</span>; 
    //     });
    
    //     return <div className="d-flex align-items-center justify-content-center flex-wrap">{reason}</div>;
    // }
    const [shapeLimit, setShapeLimit] = useState(12);
    const showMoreShape = () => setShapeLimit(newShapeData.length);
    const showLessShape = () => setShapeLimit(12);

    return (
        <>
        
            <div className="row">
                <div className="col-12 font-size-lg font-weight-bold mb-3">{language.CCMODE_THEME1_SEARCHDIAMOND_SHAPE}</div>
                <div className="col-12">
                    {newShapeData ? newShapeData.slice(0, shapeLimit).map((item) => (
                        <OverlayTrigger placement="top" key={item.id} overlay={<Tooltip id="tooltip" >{item.multilingualshape}</Tooltip>} >
                            <label className="search_btn_check">
                                <Field type="checkbox" name="Shape" id={`${item.shape}_shape`} value={item.shape}/>
                                {/* <span></span> */}
                                <div className="shapeBox selectBox">
                                    <SVG src={shapeImages?.svg?.[item.shape] || ""} />
                                </div>
                            </label>
                        </OverlayTrigger>
                    )):null}
                    {newShapeData && newShapeData.length > 12 &&
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip" >{shapeLimit === newShapeData.length ? "Less" : "More"}</Tooltip>} >
                            <span className="search_btn_check" onClick={shapeLimit === newShapeData.length ? showLessShape : showMoreShape}>
                                <div className="shapeBox selectBox">
                                    {shapeLimit === newShapeData.length ? <CiCircleMinus /> : <CiCirclePlus />}
                                </div>
                            </span>
                        </OverlayTrigger>
                    }
                </div>
            </div>
        </>
    );
};
